import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton } from '@mui/material';
import { useHistory } from 'react-router';

export const PageBackButton = ({ to }: { to?: string }) => {
  const history = useHistory();

  return (
    <IconButton
      size="small"
      color="secondary"
      onClick={() => (to ? history.push(to) : window.history.back())}
      sx={{ ml: -1, mr: -0.5 }}
    >
      <ArrowBackIcon fontSize="small" />
    </IconButton>
  );
};
